module.exports = __webpack_public_path__ + "static/media/WB 2 Student 3.bd91f248.svg";